export default function Configure($breadcrumbProvider) {
    $breadcrumbProvider.setOptions({
        template: require('../views/breadcrumbs.html')
    });
}

Configure.$inject = ['$breadcrumbProvider'];
